module.exports = __webpack_public_path__ + "img/ibanner.16b87ac7.png";